import { render, staticRenderFns } from "./PropsTable.vue?vue&type=template&id=4b5269fe&scoped=true"
import script from "./PropsTable.vue?vue&type=script&lang=js"
export * from "./PropsTable.vue?vue&type=script&lang=js"
import style0 from "./PropsTable.vue?vue&type=style&index=0&id=4b5269fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5269fe",
  null
  
)

export default component.exports